export default () => ({
  // API Calls
  basePath: '',
  epicsState: '',
  progressTracking: '',
  isProgressTrackingActive: true,
  filterParams: null,
  isShowingMilestones: true,
  milestonesType: '',
  isShowingLabels: false,

  // Data
  epicIid: '',
  epics: [],
  pageInfo: null,
  childrenEpics: {},
  childrenFlags: {},
  visibleEpics: [],
  epicIds: [],
  currentGroupId: -1,
  fullPath: '',
  timeframe: [],
  presetType: '',
  timeframeRangeType: '',
  sortedBy: '',
  milestoneIds: [],
  milestones: [],
  bufferSize: 0,

  // UI Flags
  defaultInnerHeight: 0,
  isChildEpics: false,
  hasFiltersApplied: false,
  epicsFetchInProgress: false,
  epicsFetchForTimeframeInProgress: false,
  epicsFetchForNextPageInProgress: false,
  epicsFetchFailure: false,
  epicsFetchResultEmpty: false,
  milestonesFetchInProgress: false,
  milestonesFetchFailure: false,
  milestonesFetchResultEmpty: false,
  allowScopedLabels: false,
  allowSubEpics: false,
});
